import type { ProductType } from '@/services';
import type { ProposalCategories } from '@/services/proposals/types';

/**
 * Código InsureMO do produto empresarial (Seguro Empresarial).
 * Mantemos em uma constante local para espelhar o `BUSINESS_PRODUCT_CODE`
 * do backend (`Portal.Api/src/policies/shared/business/factory`) sem criar
 * acoplamento direto entre camadas.
 */
export const BUSINESS_PRODUCT_CODE = '180007';

/** Capital Global — schema em `GET .../proposals/schema?category=OTHER`. */
export const CAPITAL_GLOBAL_PRODUCT_CODE = '930015';

export function isBusinessProductCode(
  productCode: string | undefined | null
): boolean {
  return productCode != null && productCode === BUSINESS_PRODUCT_CODE;
}

export function isCapitalGlobalProductCode(
  productCode: string | undefined | null
): boolean {
  return productCode != null && productCode === CAPITAL_GLOBAL_PRODUCT_CODE;
}

/**
 * Deriva a categoria da proposta a partir do `productCode` devolvido pelo
 * backend. Fluxo Capital Global usa rota dedicada; esta função permanece para
 * residencial / empresarial.
 */
export function getProposalCategory(
  productCode: string | undefined | null
): ProposalCategories {
  if (isBusinessProductCode(productCode)) return 'BUSINESS_INSURANCE';
  if (isCapitalGlobalProductCode(productCode)) return 'OTHER';
  return 'HOME_INSURANCE';
}

export function getProposalCategoryLabel(category: ProposalCategories): string {
  switch (category) {
    case 'BUSINESS_INSURANCE':
      return 'Empresarial';
    case 'OTHER':
      return 'Capital Global';
    case 'HOME_INSURANCE':
    default:
      return 'Residencial';
  }
}

/**
 * `ProductType` a usar no catálogo de formas de pagamento
 * (`GET /portal/v1/services/payment-type/:productType`).
 *
 * O catálogo é POR PRODUTO na DataTable `PaymentMethod` do InsureMO, e cada um
 * oferece o seu: o residencial tem PIX e cartão, o empresarial não. Mandar o
 * tipo errado não dá erro — devolve 200 com o combo de outro seguro, e o
 * corretor escolhe uma forma que o produto dele não aceita.
 */
export function getPaymentProductType(
  category: ProposalCategories
): ProductType {
  switch (category) {
    case 'BUSINESS_INSURANCE':
      return 'BUSINESS_INSURANCE';
    case 'OTHER':
      return 'CAPITAL_GLOBAL';
    case 'HOME_INSURANCE':
    default:
      return 'HOME_INSURANCE';
  }
}
